import {useEffect} from 'react'

declare global {
  interface Window {
    fbq: any
  }
}

const useMetaPixelTimeSpent = () => {
  const oneMin = 60 * 1000
  function timeSpentTrigger(eventName: string) {
    window?.fbq('trackCustom', eventName)
  }

  useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined
    const maxEventLimit = 6
    startEventSequence()

    function startEventSequence() {
      let index = 0
      timer = window.setInterval(() => {
        index += 1
        const eventName = `${index}-min-spend`

        timeSpentTrigger(eventName)

        if (index === maxEventLimit) {
          clearInterval(timer)
        }
      }, oneMin)
    }

    return () => {
      clearInterval(timer)
    }
  }, [])
}

export default useMetaPixelTimeSpent
